/* */ 
"use strict";
var core_1 = require('@angular/core');
var core_private_1 = require('../core_private');
var lang_1 = require('./facade/lang');
var exceptions_1 = require('./facade/exceptions');
var collection_1 = require('./facade/collection');
var ViewResolver = (function() {
  function ViewResolver(_reflector) {
    this._cache = new collection_1.Map();
    if (lang_1.isPresent(_reflector)) {
      this._reflector = _reflector;
    } else {
      this._reflector = core_1.reflector;
    }
  }
  ViewResolver.prototype.resolve = function(component) {
    var view = this._cache.get(component);
    if (lang_1.isBlank(view)) {
      view = this._resolve(component);
      this._cache.set(component, view);
    }
    return view;
  };
  ViewResolver.prototype._resolve = function(component) {
    var compMeta;
    var viewMeta;
    this._reflector.annotations(component).forEach(function(m) {
      if (m instanceof core_1.ViewMetadata) {
        viewMeta = m;
      }
      if (m instanceof core_1.ComponentMetadata) {
        compMeta = m;
      }
    });
    if (lang_1.isPresent(compMeta)) {
      if (lang_1.isBlank(compMeta.template) && lang_1.isBlank(compMeta.templateUrl) && lang_1.isBlank(viewMeta)) {
        throw new exceptions_1.BaseException("Component '" + lang_1.stringify(component) + "' must have either 'template' or 'templateUrl' set.");
      } else if (lang_1.isPresent(compMeta.template) && lang_1.isPresent(viewMeta)) {
        this._throwMixingViewAndComponent("template", component);
      } else if (lang_1.isPresent(compMeta.templateUrl) && lang_1.isPresent(viewMeta)) {
        this._throwMixingViewAndComponent("templateUrl", component);
      } else if (lang_1.isPresent(compMeta.directives) && lang_1.isPresent(viewMeta)) {
        this._throwMixingViewAndComponent("directives", component);
      } else if (lang_1.isPresent(compMeta.pipes) && lang_1.isPresent(viewMeta)) {
        this._throwMixingViewAndComponent("pipes", component);
      } else if (lang_1.isPresent(compMeta.encapsulation) && lang_1.isPresent(viewMeta)) {
        this._throwMixingViewAndComponent("encapsulation", component);
      } else if (lang_1.isPresent(compMeta.styles) && lang_1.isPresent(viewMeta)) {
        this._throwMixingViewAndComponent("styles", component);
      } else if (lang_1.isPresent(compMeta.styleUrls) && lang_1.isPresent(viewMeta)) {
        this._throwMixingViewAndComponent("styleUrls", component);
      } else if (lang_1.isPresent(viewMeta)) {
        return viewMeta;
      } else {
        return new core_1.ViewMetadata({
          templateUrl: compMeta.templateUrl,
          template: compMeta.template,
          directives: compMeta.directives,
          pipes: compMeta.pipes,
          encapsulation: compMeta.encapsulation,
          styles: compMeta.styles,
          styleUrls: compMeta.styleUrls
        });
      }
    } else {
      if (lang_1.isBlank(viewMeta)) {
        throw new exceptions_1.BaseException("Could not compile '" + lang_1.stringify(component) + "' because it is not a component.");
      } else {
        return viewMeta;
      }
    }
    return null;
  };
  ViewResolver.prototype._throwMixingViewAndComponent = function(propertyName, component) {
    throw new exceptions_1.BaseException("Component '" + lang_1.stringify(component) + "' cannot have both '" + propertyName + "' and '@View' set at the same time\"");
  };
  ViewResolver.decorators = [{type: core_1.Injectable}];
  ViewResolver.ctorParameters = [{type: core_private_1.ReflectorReader}];
  return ViewResolver;
}());
exports.ViewResolver = ViewResolver;
